"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var colorShades_1 = __importStar(require("./utils/colorShades"));
var theme_json_1 = __importDefault(require("./generated/theme.json"));
var otherColors_1 = __importDefault(require("./utils/otherColors"));
var utils_1 = require("../utils");
require("../utils/fonts");
var PRIMARY_COLOR = 'info';
var DEFAULT_RADIUS = 0;
var Sawmill = function (_a) {
    var colorScheme = _a.colorScheme, customColors = _a.customColors;
    var colors = (customColors === null || customColors === void 0 ? void 0 : customColors.variant) ? (0, colorShades_1.default)(colorScheme, customColors.variant) : theme_json_1.default.colors[colorScheme];
    var other = {
        colors: customColors ? (0, otherColors_1.default)(colorScheme, customColors) : theme_json_1.default.other.colors[colorScheme],
        shades: (0, colorShades_1.colorShadeUtils)(colors, colorScheme),
        fonts: theme_json_1.default.other.fonts,
    };
    return {
        defaultRadius: DEFAULT_RADIUS,
        breakpoints: theme_json_1.default.breakpoints,
        colors: colors,
        colorScheme: colorScheme,
        fontFamily: theme_json_1.default.fontFamily,
        fontFamilyMonospace: theme_json_1.default.fontFamilyMonospace,
        fontSizes: theme_json_1.default.fontSizes,
        headings: theme_json_1.default.headings,
        other: other,
        primaryColor: PRIMARY_COLOR,
        primaryShade: colorShades_1.PRIMARY_SHADES,
        spacing: theme_json_1.default.spacing,
        utils: {
            colorLevel: (0, utils_1.colorLevel)(other.colors.brand.tertiary, other.colors.brand.secondary),
            readableColor: (0, utils_1.readableColor)(other.colors.brand.tertiary, other.colors.brand.secondary),
            opacify: utils_1.opacify,
            contrastingColor: utils_1.contrastingColor,
        },
    };
};
exports.default = Sawmill;
